import { instance } from "./api";
import tokenService from "./token.service";

// import api from "./api";
class AuthService {
  async login(loginPayloads) {
    const fd = new FormData();
    fd.append("Login_Email", loginPayloads.email);
    fd.append("Login_Password", loginPayloads.password);
    const response = await instance.post("auth/login", fd);
    // console.log(response.data);
    if (response.status === 200) {
      // console.log("if");
      tokenService.setToken(response.data.token);
      sessionStorage.setItem("name", response.data.data.name);
      sessionStorage.setItem("role", response.data.data.role);
      sessionStorage.setItem("passwordType", response.data.data.tempPassword); //true means need to reset password

      // console.log(first)
      sessionStorage.setItem("loginToken", response.data.token);
    }
    // console.log("ehte");
    return response.data;
  }

  async forgetPassword(loginPayloads) {
    const fd = new FormData();
    fd.append("Login_Email", loginPayloads.email);
    const response = await instance.post("auth/forgotPassword", fd);
    // if (response.status === 200) {
    //   console.log('if');
    //   tokenService.setToken(response.data.token);
    //   sessionStorage.setItem('name', response.data.data.name);
    //   sessionStorage.setItem('role', response.data.data.role);
    //   sessionStorage.setItem('passwordType', response.data.data.tempPassword); //true means need to reset password

    //   // console.log(first)
    //   sessionStorage.setItem('loginToken', response.data.token);
    // }
    return response.data;
  }

  async changePassword(payloads) {
    const fd = new FormData();
    fd.append("old_Password", payloads.currentPassword);
    fd.append("new_Password", payloads.newPassword);
    const response = await instance.post("user/changePassword", fd);
    // if (response.status === 200) {
    //   console.log('if');
    //   tokenService.setToken(response.data.token);
    //   sessionStorage.setItem('name', response.data.data.name);
    //   sessionStorage.setItem('role', response.data.data.role);
    //   sessionStorage.setItem('passwordType', response.data.data.tempPassword); //true means need to reset password

    //   // console.log(first)
    //   sessionStorage.setItem('loginToken', response.data.token);
    // }
    return response.data;
  }

  autoAuthLogin() {
    return instance.get("auth/autoLogin").then((response) => {
      if (response.status === 200) {
        tokenService.setToken(response.data.data.token);
        sessionStorage.setItem("empCode", response.data.data.userId);
        sessionStorage.setItem("empName", response.data.data.userName);
        // console.log(first)
        if (response.data.data.role.length > 1) {
          sessionStorage.setItem("roles", response.data.data.role);
        } else {
          sessionStorage.setItem("userSelectType", response.data.data.role[0]);
          sessionStorage.setItem("roles", response.data.data.role);
        }
        sessionStorage.setItem(
          "loginHistory",
          response.data.data.loginhistory.Last_Login
        );
        sessionStorage.setItem("loginToken", response.data.data.token);
      }
      return response.data;
    });
  }

  logout() {
    return instance.get("auth/").then((res) => {
      sessionStorage.clear();
      tokenService.removeToken();
      return res.data;
    });
  }
}

// const authService = {
//   register,
//   login,
//   logout,
// };

export default new AuthService();
